import axios from 'axios';
import i18n from '../../../i18n';
import { getBaseUrl } from '../../../utils/getUrl';

const getApi = () => getBaseUrl();

const getUserId = () => +localStorage.getItem('idKorisnika');

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

const isPlaceholderTabMeta = (tab) => {
  if (!tab) return true;
  const title = tab.Title ?? tab.title;
  const icon = tab.Icon ?? tab.icon;
  return title === 'A' || icon === 'A' || title == null || title === '';
};

/**
 * Rešava tab navigaciju iz notifikacije (isti princip kao Turbo viseDetalja).
 */
export const resolveNotificationTab = (item) => {
  const tab = item?.Tab || item?.tab || null;
  const idObjekta = item?.idObjekta ?? item?.IdObjekta ?? null;
  const izvorTabela = item?.izvorTabela ?? item?.IzvorTabela ?? null;
  const message = String(item?.Poruka || item?.poruka || item?.message || '');
  const type = tab?.Type ?? tab?.type ?? null;

  // Pregled zahteva ucitava po IdDok; "id" ne sme biti IdDok jer se
  // procitano snima po DokServisniZahtevi.Id
  if (
    idObjekta &&
    (izvorTabela === 'DokServisniZahtevi' || /servisni\s+zahtev/i.test(message))
  ) {
    return {
      type: 10014,
      title: 'Pregled zahteva',
      icon: 'fas fa-clipboard',
      data: { notifikacija: true, idDok: idObjekta },
    };
  }

  const buildData = (id) => ({
    notifikacija: true,
    id,
    idDok: id,
    idObjekta: id,
  });

  if (type && !isPlaceholderTabMeta(tab)) {
    return {
      type,
      title:
        tab.Title && tab.Title !== 'A'
          ? tab.Title
          : i18n.t('notifications.defaultTitle'),
      icon: tab.Icon && tab.Icon !== 'A' ? tab.Icon : 'fas fa-bell',
      data: buildData(idObjekta),
    };
  }

  if (type && Number(type) > 1) {
    return {
      type: Number(type),
      title: i18n.t('notifications.defaultTitle'),
      icon: 'fas fa-bell',
      data: buildData(idObjekta),
    };
  }

  return null;
};

/** Mapira Inmold/Turbo API model na UI model */
export const mapApiNotification = (item) => {
  const message = item.Poruka || item.poruka || item.message || '';
  const resolvedTab = resolveNotificationTab(item);

  const colonIndex = String(message).indexOf(':');
  const title =
    colonIndex > 0
      ? String(message).slice(0, colonIndex).trim()
      : String(message).trim() || i18n.t('notifications.defaultTitle');
  const detail =
    colonIndex > 0
      ? String(message)
          .slice(colonIndex + 1)
          .trim()
      : '';

  return {
    id: item.Id ?? item.id,
    title,
    subtitle: detail || message,
    fullMessage: message,
    read: Boolean(item.Procitani ?? item.procitana ?? item.read),
    time: item.VremeKreiranja || item.vremeUnosa || item.time || null,
    icon: 'fas fa-bell',
    color: '#ff8f28',
    avatar: item.avatar,
    pageType: resolvedTab?.type ?? null,
    pageTitle: resolvedTab?.title ?? null,
    pageIcon: resolvedTab?.icon ?? null,
    pageData: resolvedTab?.data ?? null,
    hasDetails: Boolean(resolvedTab?.type),
    idObjekta: item.idObjekta ?? item.IdObjekta ?? null,
    raw: item,
  };
};

export const fetchUnreadCount = async () => {
  const userId = getUserId();
  if (!userId) return 0;

  try {
    const response = await axios.post(
      `${getApi()}FirebaseNotification/unreadCount`,
      { userId },
      { headers: authHeaders() },
    );
    return Number(response.data?.unreadCount ?? 0);
  } catch (error) {
    console.error('Error fetching unread notifications count:', error);
    return 0;
  }
};

export const fetchNotifications = async ({
  unreadOnly = false,
  offset = 0,
  next = 50,
} = {}) => {
  const userId = getUserId();
  if (!userId) return [];

  try {
    const response = await axios.post(
      `${getApi()}FirebaseNotification/getNotifications`,
      {
        userId,
        idKorisnika: userId,
        unread: unreadOnly,
        offset,
        next,
      },
      { headers: authHeaders() },
    );

    const list = Array.isArray(response.data) ? response.data : [];
    return list.map(mapApiNotification);
  } catch (error) {
    console.error('Error fetching notifications:', error);
    return [];
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    await axios.post(
      `${getApi()}FirebaseNotification/markAsRead`,
      {
        notificationId,
      },
      { headers: authHeaders() },
    );
    return true;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    return false;
  }
};

export const markAllNotificationsAsRead = async () => {
  const userId = getUserId();
  if (!userId) return false;

  try {
    await axios.post(
      `${getApi()}FirebaseNotification/markiraj_sve_kao_procitano`,
      { idKorProm: userId },
      { headers: authHeaders() },
    );
    return true;
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    return false;
  }
};

export const getNotifications = async () => fetchNotifications();
export const onReadFirebase = async (item) =>
  markNotificationAsRead(item?.id ?? item?.Id);
export const onReadAllFirebase = async () => markAllNotificationsAsRead();
